export const EMPTY_COLLECTIONS = [];
